<template>
  <div class="donator_thankyou">
    <div class="container">
   	<div class="row">
   		<div class="col-md-12">
      <h3>Hartelijk bedankt voor uw aanmelding!</h3>
      <h1>Wordt online collectant!</h1>
      <p>Omdat wij een kleinschallige organisatie zijn, collecteren wij niet langs de deur. Maar we zoeken altijd collectanten om online collectes te lopen! Voel je vrij om voor ons binnen uw netwerk te collecteren!</p>
      <p>
      	<a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=wijhebbeenschisis.nl/doneren"><button>Facebook</button></a>
      	<a target="_blank" href="https://twitter.com/home?status=Ik%20heb%20geld%20gedoneerd%20aan%20Stichting%20Vrienden%20van%20Schisisonderzoek,%20heb%20jij%20ook%20een%20zakcentje%20over?%20%23vriendenvanschisisonderzoek%20https%3A//schisisonderzoek.nl"><button>Twitter</button></a>
      	<a target="_blank" href="https://plus.google.com/share?url=schisisonderzoek.nl/doneren"><button>Google+</button></a>
      </p>
    </div>
   </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Donator_thankyou'
}
</script>



// WEBPACK FOOTER //
// src/components/donator/Thankyou.vue